import dayjs from "dayjs"
import { map } from "lodash"

const fiveYearsMonth = 60
const settlementPeriodMonth = 3

const getSomeMonths = (month: number, scope: "past" | "future") => {
  return map(Array.from(new Array(month)).map((v, i) => i), (num: number) => {
    if (scope === "past") {
      return dayjs()
        .subtract(num, "month")
        .format("YYYY/MM")
    } else if (scope === "future") {
      return dayjs()
        .add(num, "month")
        .format("YYYY/MM")
    }
  })
}

export const Sort = {
  IndexType: [
    {
      id: 0,
      name: "ベンチマーク",
      apiCall: "Top.Summary.Benchmark",
      displayCountry: false,
    },
    {
      id: 1,
      name: "株式指数",
      apiCall: "Top.Summary.Index.World",
      displayCountry: true,
    },
    {
      id: 2,
      name: "外国為替",
      apiCall: "Top.Summary.FX.World",
      displayCountry: true,
    },
    {
      id: 3,
      name: "国債",
      apiCall: "Top.Summary.GB.World",
      displayCountry: true,
    },
    { id: 4, name: "商品", apiCall: "Top.Commodity", displayCountry: false },
    { id: 5, name: "政策金利", apiCall: "Top.PIR", displayCountry: false },
  ],
  IndexCountry: [
    { id: 0, name: "ワールド", apiCall: "Top.Summary.Index.World" },
    { id: 1, name: "日本", apiCall: "Top.Summary.Index.Jpn" },
    { id: 2, name: "アジア", apiCall: "Top.Summary.Index.Asian" },
    { id: 3, name: "その他", apiCall: "Top.Summary.Index.Other" },
    { id: 4, name: "全て", apiCall: "Top.Summary.Index.All" },
  ],
  IndexCountryFX: [
    { id: 0, name: "ワールド", apiCall: "Top.Summary.FX.World" },
    { id: 1, name: "アジア", apiCall: "Top.Summary.FX.Asian" },
    { id: 2, name: "その他", apiCall: "Top.Summary.FX.Other" },
    { id: 3, name: "全て", apiCall: "Top.Summary.FX.All" },
  ],
  IndexCountryGB: [
    { id: 0, name: "ワールド", apiCall: "Top.Summary.GB.World" },
    { id: 1, name: "アジア", apiCall: "Top.Summary.GB.Asian" },
    { id: 2, name: "その他", apiCall: "Top.Summary.GB.Other" },
    { id: 3, name: "全て", apiCall: "Top.Summary.GB.All" },
  ],
  Indicator: [
    {
      id: 0,
      name: "日本",
      apiCall: [
        "Top.Summary.Jpn.Today",
        "Top.Summary.Jpn.PrevDays",
        "Top.Summary.Jpn.NextDays",
        "Top.Summary.Jpn.CurMonth",
      ],
    },
    {
      id: 1,
      name: "アジア",
      apiCall: [
        "Top.Summary.Asian.Today",
        "Top.Summary.Asian.PrevDays",
        "Top.Summary.Asian.NextDays",
        "Top.Summary.Asian.CurMonth",
      ],
    },
    {
      id: 2,
      name: "その他",
      apiCall: [
        "Top.Summary.Other.Today",
        "Top.Summary.Other.PrevDays",
        "Top.Summary.Other.NextDays",
        "Top.Summary.Other.CurMonth",
      ],
    },
    {
      id: 3,
      name: "全て",
      apiCall: [
        "Top.Summary.All.Today",
        "Top.Summary.All.PrevDays",
        "Top.Summary.All.NextDays",
        "Top.Summary.All.CurMonth",
      ],
    },
  ],
  //ランキング国内株市場
  RankingExchangeFull: [
    {
      id: 0,
      name: "日経平均",
      rankingType: "RankingSortByNikkei",
      rankingTypeNum: "14",
      rankingTypeNumAsTrust: "4",
    },
    {
      id: 1,
      name: "東証1部",
      rankingType: "RankingSortFull",
      rankingTypeNum: "03",
      rankingTypeNumAsTrust: "7",
    },
    {
      id: 2,
      name: "東証2部",
      rankingType: "RankingSortFull",
      rankingTypeNum: "04",
      rankingTypeNumAsTrust: "8",
    },
    {
      id: 3,
      name: "東証マザーズ",
      rankingType: "RankingSortByOther",
      rankingTypeNum: "05",
    },
    {
      id: 4,
      name: "JASDAQ",
      rankingType: "RankingSortByOther",
      rankingTypeNum: "09",
    },
    {
      id: 5,
      name: "名証",
      rankingType: "RankingSortByOther",
      rankingTypeNum: "11",
    },
    {
      id: 6,
      name: "福証",
      rankingType: "RankingSortByOther",
      rankingTypeNum: "12",
    },
    {
      id: 7,
      name: "札証",
      rankingType: "RankingSortByOther",
      rankingTypeNum: "13",
    },
    {
      id: 8,
      name: "業種別株価指数",
      rankingType: "RankingSortByIndustry",
      rankingTypeNum: "80",
    },
    {
      id: 9,
      name: "国内全市場",
      rankingType: "RankingSortFull",
      rankingTypeNum: "01",
      rankingTypeNumAsTrust: "1",
    },
  ],
  //ランキング外国株市場
  ForeignRankingExchangeFull: [
    {
      id: 0,
      name: "米国全て",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "140",
      icon: "icon-solid icon-us",
    },
    {
      id: 1,
      name: "NYSE",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "141",
      icon: "icon-solid icon-us",
    },
    {
      id: 2,
      name: "NASDAQ",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "142",
      icon: "icon-solid icon-us",
    },
    {
      id: 3,
      name: "香港全て",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "110",
      icon: "icon-solid icon-hong-kong",
    },
    {
      id: 4,
      name: "香港",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "111",
      icon: "icon-solid icon-hong-kong",
    },
    {
      id: 5,
      name: "香港GEM",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "112",
      icon: "icon-solid icon-hong-kong",
    },
    {
      id: 6,
      name: "中国全て",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "100",
      icon: "icon-solid icon-china",
    },
    {
      id: 7,
      name: "上海A株",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "101",
      icon: "icon-solid icon-china",
    },
    {
      id: 8,
      name: "上海B株",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "102",
      icon: "icon-solid icon-china",
    },
    {
      id: 9,
      name: "深センA株",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "103",
      icon: "icon-solid icon-china",
    },
    {
      id: 10,
      name: "深センB株",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "104",
      icon: "icon-solid icon-china",
    },
    {
      id: 11,
      name: "ベトナム全て",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "130",
      icon: "icon-solid icon-vietnam",
    },
    {
      id: 12,
      name: "ホーチミン",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "131",
      icon: "icon-solid icon-vietnam",
    },
    {
      id: 13,
      name: "ハノイ",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "132",
      icon: "icon-solid icon-vietnam",
    },
    {
      id: 14,
      name: "韓国全て",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "120",
      icon: "icon-solid icon-korea",
    },
    {
      id: 15,
      name: "韓国",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "121",
      icon: "icon-solid icon-korea",
    },
    {
      id: 16,
      name: "KOSDAQ",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "122",
      icon: "icon-solid icon-korea",
    },
    {
      id: 17,
      name: "台湾",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "160",
      icon: "icon-solid icon-taiwan",
    },
    {
      id: 18,
      name: "シンガポール",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "170",
      icon: "icon-solid icon-singapore",
    },
    {
      id: 19,
      name: "タイ",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "150",
      icon: "icon-solid icon-thailand",
    },
    {
      id: 20,
      name: "マレーシア",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "190",
      icon: "icon-solid icon-malaysia",
    },
    {
      id: 21,
      name: "インドネシア",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "180",
      icon: "icon-solid icon-indonesia",
    },
    {
      id: 22,
      name: "フィリピン",
      rankingType: "RankingSortByForeign",
      rankingTypeNum: "200",
      icon: "icon-solid icon-philippines",
    },
  ],
  //ランキング(国内全市場,TOPIX,東証2部)
  RankingSortFull: [
    {
      id: 0,
      name: "出来高",
      type: "price",
      rankingTypeNum: 3,
      sortTarget: "TradVolume",
    },
    {
      id: 1,
      name: "値上がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 1,
      sortTarget: "ChangedRatio",
    },
    {
      id: 2,
      name: "値下がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 2,
      sortTarget: "ChangedRatio",
    },
    {
      id: 3,
      name: "売買代金",
      type: "trade",
      rankingTypeNum: 4,
      sortTarget: "TradValue",
    },
    {
      id: 4,
      name: "売買代金急増",
      type: "trade",
      rankingTypeNum: 7,
      sortTarget: "EstrangeFromTradValue",
    },
    {
      id: 5,
      name: "信用高倍率",
      type: "trustRate",
      rankingTypeNum: 1030,
      sortTarget: "MarginRatio",
    },
    {
      id: 6,
      name: "信用低倍率",
      type: "trustRate",
      rankingTypeNum: 1040,
      sortTarget: "MarginRatio",
    },
    {
      id: 7,
      name: "信用買残増",
      type: "trustBuy",
      rankingTypeNum: 1010,
      sortTarget: "MarginBuyQty",
    },
    {
      id: 8,
      name: "信用買残減",
      type: "trustBuy",
      rankingTypeNum: 1020,
      sortTarget: "MarginBuyQty",
    },
    {
      id: 9,
      name: "信用売残増",
      type: "trustSell",
      rankingTypeNum: 1000,
      sortTarget: "MarginSellQty",
    },
    {
      id: 10,
      name: "信用売残減",
      type: "trustSell",
      rankingTypeNum: 1001,
      sortTarget: "MarginSellQty",
    },
    {
      id: 11,
      name: "出来高急増",
      type: "price",
      rankingTypeNum: 6,
      sortTarget: "EstrangeFromTradVolume",
    },
  ],
  //ランキング(東証マザーズ,JASDAQ,名証,福証,札証)
  RankingSortByOther: [
    {
      id: 0,
      name: "出来高",
      type: "price",
      rankingTypeNum: 3,
      sortTarget: "TradVolume",
    },
    {
      id: 1,
      name: "値上がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 1,
      sortTarget: "ChangedRatio",
    },
    {
      id: 2,
      name: "値下がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 2,
      sortTarget: "ChangedRatio",
    },
    {
      id: 3,
      name: "売買代金",
      type: "trade",
      rankingTypeNum: 4,
      sortTarget: "TradValue",
    },
    {
      id: 4,
      name: "売買代金急増",
      type: "trade",
      rankingTypeNum: 7,
      sortTarget: "EstrangeFromTradValue",
    },
    {
      id: 5,
      name: "出来高急増",
      type: "price",
      rankingTypeNum: 6,
      sortTarget: "EstrangeFromTradVolume",
    },
  ],
  //ランキング(日経平均)
  RankingSortByNikkei: [
    {
      id: 0,
      name: "出来高",
      type: "price",
      rankingTypeNum: 3,
      sortTarget: "TradVolume",
    },
    {
      id: 1,
      name: "値上がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 1,
      sortTarget: "ChangedRatio",
    },
    {
      id: 2,
      name: "値下がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 2,
      sortTarget: "ChangedRatio",
    },
    {
      id: 3,
      name: "売買代金急増",
      type: "trade",
      rankingTypeNum: 7,
      sortTarget: "EstrangeFromTradValue",
    },
    {
      id: 4,
      name: "信用高倍率",
      type: "trustRate",
      rankingTypeNum: 1031,
      sortTarget: "MarginRatio",
    },
    {
      id: 5,
      name: "信用低倍率",
      type: "trustRate",
      rankingTypeNum: 1041,
      sortTarget: "MarginRatio",
    },
    {
      id: 6,
      name: "信用買残増",
      type: "trustBuy",
      rankingTypeNum: 1011,
      sortTarget: "MarginBuyQty",
    },
    {
      id: 7,
      name: "信用買残減",
      type: "trustBuy",
      rankingTypeNum: 1021,
      sortTarget: "MarginBuyQty",
    },
    {
      id: 8,
      name: "信用売残増",
      type: "trustSell",
      rankingTypeNum: 1002,
      sortTarget: "MarginSellQty",
    },
    {
      id: 9,
      name: "信用売残減",
      type: "trustSell",
      rankingTypeNum: 1003,
      sortTarget: "MarginSellQty",
    },
  ],
  //ランキング(業種別株価指数)
  RankingSortByIndustry: [
    {
      id: 0,
      name: "値上がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 1,
      sortTarget: "ChangedRatio",
    },
    {
      id: 1,
      name: "値下がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 2,
      sortTarget: "ChangedRatio",
    },
  ],
  //ランキング(外国株)
  RankingSortByForeign: [
    {
      id: 0,
      name: "出来高",
      type: "price",
      rankingTypeNum: 303,
      sortTarget: "TradVolume",
    },
    {
      id: 1,
      name: "値上がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 103,
      sortTarget: "ChangedRatio",
    },
    {
      id: 2,
      name: "値下がり率",
      type: "priceIncreaseRate",
      rankingTypeNum: 203,
      sortTarget: "ChangedRatio",
    },
  ],
  EconomicDateSortByIndustry: [
    { id: 0, name: "GDP", apiCall: "Top.Indicator.Group.GDP" },
    { id: 1, name: "消費者物価指数", apiCall: "Top.Indicator.Group.CPI" },
    { id: 2, name: "生産者物価指数", apiCall: "Top.Indicator.Group.PPI" },
    { id: 3, name: "消費者態度指数", apiCall: "Top.Indicator.Group.CCI" },
    { id: 4, name: "商業販売統計", apiCall: "Top.Indicator.Group.RS" },
    { id: 5, name: "製造業景気指数", apiCall: "Top.Indicator.Group.PMI" },
    { id: 6, name: "サービス業景気指数", apiCall: "Top.Indicator.Group.SPMI" },
    { id: 7, name: "失業率", apiCall: "Top.Indicator.Group.UER" },
    { id: 8, name: "鉱工業生産指数", apiCall: "Top.Indicator.Group.IP" },
    { id: 9, name: "中銀金融政策決定", apiCall: "Top.Indicator.Group.CBPIR" },
    { id: 10, name: "貿易収支", apiCall: "Top.Indicator.Group.TB" },
    { id: 11, name: "経常収支", apiCall: "Top.Indicator.Group.BOP" },
    { id: 12, name: "輸入物価", apiCall: "Top.Indicator.Group.IPI" },
    { id: 13, name: "輸出物価", apiCall: "Top.Indicator.Group.EPI" },
  ],
  EconomicDate: [
    // { id: 0, name: "未選択", apiCall: "", disabled: true },
    { id: 0, name: "本日発表", apiCall: "Top.Indicator.Today" },
    { id: 1, name: "過去7日間", apiCall: "Top.Indicator.PrevDays" },
    { id: 2, name: "次の7日間", apiCall: "Top.Indicator.NextDays" },
    { id: 3, name: "今月", apiCall: "Top.Indicator.CurMonth" },
    { id: 4, name: "過去分", apiCall: "Top.Indicator.CurMonth" },
    { id: 5, name: "種類別", apiCall: "Top.Indicator.Group.GDP" },
  ],
  EconomicSummaryDate: [
    { id: 0, name: "本日発表" },
    { id: 1, name: "過去7日間" },
    { id: 2, name: "次の7日間" },
    { id: 3, name: "今月" },
  ],
  EconomicForeignDate: [
    { id: 0, name: "本日発表" },
    { id: 1, name: "過去7日間" },
    { id: 2, name: "翌日以降" },
  ],
  EconomicMonth: map(
    getSomeMonths(fiveYearsMonth, "past"),
    (month: string, key: number) => {
      const apiParam = month.split("/").join("")
      return {
        id: key,
        name: month,
        apiCall: `Top.Indicator.Month.${apiParam}`,
      }
    }
  ),
  RankingSort: [
    { id: 0, name: "値上り上位" },
    { id: 1, name: "値下り上位" },
    { id: 2, name: "出来高上位" },
  ],

  //使わない？
  RankingExchange: [
    {
      id: 0,
      name: "TOPIX",
      priceIncrease: 103,
      priceReduction: 203,
      volume: 303,
    },
    {
      id: 1,
      name: "香港",
      priceIncrease: 104,
      priceReduction: 204,
      volume: 304,
    },
    {
      id: 2,
      name: "香港GEM",
      priceIncrease: 105,
      priceReduction: 205,
      volume: 305,
    },
    {
      id: 3,
      name: "上海B株",
      priceIncrease: 109,
      priceReduction: 209,
      volume: 309,
    },
    {
      id: 4,
      name: "韓国",
      priceIncrease: 111,
      priceReduction: 211,
      volume: 311,
    },
    {
      id: 5,
      name: "台湾",
      priceIncrease: 112,
      priceReduction: 212,
      volume: 312,
    },
  ],

  WorldSummaryRankingExchange: [
    {
      id: 0,
      name: "日経平均",
      priceIncrease: 114,
      priceReduction: 214,
      volume: 314,
      link: "/domestic/ranking",
      transitionExchange: 0,
    },
    {
      id: 1,
      name: "東証1部",
      priceIncrease: 103,
      priceReduction: 203,
      volume: 303,
      link: "/domestic/ranking",
      transitionExchange: 1,
    },
    {
      id: 2,
      name: "東証2部",
      priceIncrease: 104,
      priceReduction: 204,
      volume: 304,
      link: "/domestic/ranking",
      transitionExchange: 2,
    },
    {
      id: 3,
      name: "東証マザーズ",
      priceIncrease: 105,
      priceReduction: 205,
      volume: 305,
      link: "/domestic/ranking",
      transitionExchange: 3,
    },
    {
      id: 4,
      name: "JASDAQ",
      priceIncrease: 109,
      priceReduction: 209,
      volume: 309,
      link: "/domestic/ranking",
      transitionExchange: 4,
    },
    {
      id: 5,
      name: "名証",
      priceIncrease: 111,
      priceReduction: 211,
      volume: 311,
      link: "/domestic/ranking",
      transitionExchange: 5,
    },
    {
      id: 6,
      name: "福証",
      priceIncrease: 112,
      priceReduction: 212,
      volume: 312,
      link: "/domestic/ranking",
      transitionExchange: 6,
    },
    {
      id: 7,
      name: "札証",
      priceIncrease: 113,
      priceReduction: 213,
      volume: 313,
      link: "/domestic/ranking",
      transitionExchange: 7,
    },
    {
      id: 8,
      name: "業種別株価指数",
      priceIncrease: 801,
      priceReduction: 802,
      link: "/domestic/ranking",
      transitionExchange: 8,
    },
    {
      id: 9,
      name: "国内全市場",
      priceIncrease: 101,
      priceReduction: 201,
      volume: 301,
      link: "/domestic/ranking",
      transitionExchange: 9,
    },
    {
      id: 10,
      name: "米国全て",
      priceIncrease: 140103,
      priceReduction: 140203,
      volume: 140303,
      link: "/overseas/ranking",
      transitionExchange: 0,
    },
    {
      id: 11,
      name: "NYSE",
      priceIncrease: 141103,
      priceReduction: 141203,
      volume: 141303,
      link: "/overseas/ranking",
      transitionExchange: 1,
    },
    {
      id: 12,
      name: "NASDAQ",
      priceIncrease: 142103,
      priceReduction: 142203,
      volume: 142303,
      link: "/overseas/ranking",
      transitionExchange: 2,
    },
    {
      id: 13,
      name: "香港全て",
      priceIncrease: 110103,
      priceReduction: 110203,
      volume: 110303,
      link: "/overseas/ranking",
      transitionExchange: 3,
    },
    {
      id: 14,
      name: "香港",
      priceIncrease: 111103,
      priceReduction: 111203,
      volume: 111303,
      link: "/overseas/ranking",
      transitionExchange: 4,
    },
    {
      id: 15,
      name: "香港GEM",
      priceIncrease: 112103,
      priceReduction: 112203,
      volume: 112303,
      link: "/overseas/ranking",
      transitionExchange: 5,
    },
    {
      id: 16,
      name: "中国全て",
      priceIncrease: 100103,
      priceReduction: 100203,
      volume: 100303,
      link: "/overseas/ranking",
      transitionExchange: 6,
    },
    {
      id: 17,
      name: "上海A株",
      priceIncrease: 101103,
      priceReduction: 101203,
      volume: 101303,
      link: "/overseas/ranking",
      transitionExchange: 7,
    },
    {
      id: 18,
      name: "上海B株",
      priceIncrease: 102103,
      priceReduction: 102203,
      volume: 102303,
      link: "/overseas/ranking",
      transitionExchange: 8,
    },
    {
      id: 19,
      name: "深センA株",
      priceIncrease: 103103,
      priceReduction: 103203,
      volume: 103303,
      link: "/overseas/ranking",
      transitionExchange: 9,
    },
    {
      id: 20,
      name: "深センB株",
      priceIncrease: 104103,
      priceReduction: 104203,
      volume: 104303,
      link: "/overseas/ranking",
      transitionExchange: 10,
    },
    {
      id: 21,
      name: "ベトナム全て",
      priceIncrease: 130103,
      priceReduction: 130203,
      volume: 130303,
      link: "/overseas/ranking",
      transitionExchange: 11,
    },
    {
      id: 22,
      name: "ホーチミン",
      priceIncrease: 131103,
      priceReduction: 131203,
      volume: 131303,
      link: "/overseas/ranking",
      transitionExchange: 12,
    },
    {
      id: 23,
      name: "ハノイ",
      priceIncrease: 132103,
      priceReduction: 132203,
      volume: 132303,
      link: "/overseas/ranking",
      transitionExchange: 13,
    },
    {
      id: 24,
      name: "韓国全て",
      priceIncrease: 120103,
      priceReduction: 120203,
      volume: 120303,
      link: "/overseas/ranking",
      transitionExchange: 14,
    },
    {
      id: 25,
      name: "韓国",
      priceIncrease: 121103,
      priceReduction: 121203,
      volume: 121303,
      link: "/overseas/ranking",
      transitionExchange: 15,
    },
    {
      id: 26,
      name: "KOSDAQ",
      priceIncrease: 122103,
      priceReduction: 122203,
      volume: 122303,
      link: "/overseas/ranking",
      transitionExchange: 16,
    },
    {
      id: 27,
      name: "台湾",
      priceIncrease: 160103,
      priceReduction: 160203,
      volume: 160303,
      link: "/overseas/ranking",
      transitionExchange: 17,
    },
    {
      id: 28,
      name: "シンガポール",
      priceIncrease: 170103,
      priceReduction: 170203,
      volume: 170303,
      link: "/overseas/ranking",
      transitionExchange: 18,
    },
    {
      id: 29,
      name: "タイ",
      priceIncrease: 150103,
      priceReduction: 150203,
      volume: 150303,
      link: "/overseas/ranking",
      transitionExchange: 19,
    },
    {
      id: 30,
      name: "マレーシア",
      priceIncrease: 190103,
      priceReduction: 190203,
      volume: 190303,
      link: "/overseas/ranking",
      transitionExchange: 20,
    },
    {
      id: 31,
      name: "インドネシア",
      priceIncrease: 180103,
      priceReduction: 180203,
      volume: 180303,
      link: "/overseas/ranking",
      transitionExchange: 21,
    },
    {
      id: 32,
      name: "フィリピン",
      priceIncrease: 200103,
      priceReduction: 200203,
      volume: 200303,
      link: "/overseas/ranking",
      transitionExchange: 22,
    },
  ],
  DomesticSummaryRankingExchange: [
    {
      id: 0,
      name: "国内全市場",
      priceIncrease: 101,
      priceReduction: 201,
      volume: 301,
      link: "/domestic/ranking",
      transitionExchange: 9,
    },
    {
      id: 1,
      name: "東証1部",
      priceIncrease: 103,
      priceReduction: 203,
      volume: 303,
      link: "/domestic/ranking",
      transitionExchange: 1,
    },
    {
      id: 2,
      name: "JASDAQ",
      priceIncrease: 109,
      priceReduction: 209,
      volume: 309,
      link: "/domestic/ranking",
      transitionExchange: 4,
    },
    {
      id: 3,
      name: "東証マザーズ",
      priceIncrease: 105,
      priceReduction: 205,
      volume: 305,
      link: "/domestic/ranking",
      transitionExchange: 3,
    },
  ],
  //米国
  US_Ranking: [
    {
      id: 0,
      name: "米国全て",
      priceIncrease: 140103,
      priceReduction: 140203,
      volume: 140303,
      link: "/overseas/ranking",
      transitionExchange: 0,
    },
    {
      id: 1,
      name: "NYSE",
      priceIncrease: 141103,
      priceReduction: 141203,
      volume: 141303,
      link: "/overseas/ranking",
      transitionExchange: 1,
    },
    {
      id: 2,
      name: "NASDAQ",
      priceIncrease: 142103,
      priceReduction: 142203,
      volume: 142303,
      link: "/overseas/ranking",
      transitionExchange: 2,
    },
  ],
  //香港
  HongKong_Ranking: [
    {
      id: 0,
      name: "香港全て",
      priceIncrease: 110103,
      priceReduction: 110203,
      volume: 110303,
      link: "/overseas/ranking",
      transitionExchange: 3,
    },
    {
      id: 1,
      name: "香港",
      priceIncrease: 111103,
      priceReduction: 111203,
      volume: 111303,
      link: "/overseas/ranking",
      transitionExchange: 4,
    },
    {
      id: 2,
      name: "香港GEM",
      priceIncrease: 112103,
      priceReduction: 112203,
      volume: 112303,
      link: "/overseas/ranking",
      transitionExchange: 5,
    },
  ],
  //中国
  China_Ranking: [
    {
      id: 0,
      name: "中国全て",
      priceIncrease: 100103,
      priceReduction: 100203,
      volume: 100303,
      link: "/overseas/ranking",
      transitionExchange: 6,
    },
    {
      id: 1,
      name: "上海A株",
      priceIncrease: 101103,
      priceReduction: 101203,
      volume: 101303,
      link: "/overseas/ranking",
      transitionExchange: 7,
    },
    {
      id: 2,
      name: "上海B株",
      priceIncrease: 102103,
      priceReduction: 102203,
      volume: 102303,
      link: "/overseas/ranking",
      transitionExchange: 8,
    },
    {
      id: 3,
      name: "深センA株",
      priceIncrease: 103103,
      priceReduction: 103203,
      volume: 103303,
      link: "/overseas/ranking",
      transitionExchange: 9,
    },
    {
      id: 4,
      name: "深センB株",
      priceIncrease: 104103,
      priceReduction: 104203,
      volume: 104303,
      link: "/overseas/ranking",
      transitionExchange: 10,
    },
  ],
  //ベトナム
  Vietnam_Ranking: [
    {
      id: 0,
      name: "ベトナム全て",
      priceIncrease: 130103,
      priceReduction: 130203,
      volume: 130303,
      link: "/overseas/ranking",
      transitionExchange: 11,
    },
    {
      id: 1,
      name: "ホーチミン",
      priceIncrease: 131103,
      priceReduction: 131203,
      volume: 131303,
      link: "/overseas/ranking",
      transitionExchange: 12,
    },
    {
      id: 2,
      name: "ハノイ",
      priceIncrease: 132103,
      priceReduction: 132203,
      volume: 132303,
      link: "/overseas/ranking",
      transitionExchange: 13,
    },
  ],
  //韓国
  Korea_Ranking: [
    {
      id: 0,
      name: "韓国全て",
      priceIncrease: 120103,
      priceReduction: 120203,
      volume: 120303,
      link: "/overseas/ranking",
      transitionExchange: 14,
    },
    {
      id: 1,
      name: "韓国",
      priceIncrease: 121103,
      priceReduction: 121203,
      volume: 121303,
      link: "/overseas/ranking",
      transitionExchange: 15,
    },
    {
      id: 2,
      name: "KOSDAQ",
      priceIncrease: 122103,
      priceReduction: 122203,
      volume: 122303,
      link: "/overseas/ranking",
      transitionExchange: 16,
    },
  ],
  //台湾
  Taiwan_Ranking: [
    {
      id: 0,
      name: "台湾",
      priceIncrease: 160103,
      priceReduction: 160203,
      volume: 160303,
      link: "/overseas/ranking",
      transitionExchange: 17,
    },
  ],
  //シンガポール
  Singapore_Ranking: [
    {
      id: 0,
      name: "シンガポール",
      priceIncrease: 170103,
      priceReduction: 170203,
      volume: 170303,
      link: "/overseas/ranking",
      transitionExchange: 18,
    },
  ],
  //タイ
  Thailand_Ranking: [
    {
      id: 0,
      name: "タイ",
      priceIncrease: 150103,
      priceReduction: 150203,
      volume: 150303,
      link: "/overseas/ranking",
      transitionExchange: 19,
    },
  ],
  //マレーシア
  Malaysia_Ranking: [
    {
      id: 0,
      name: "マレーシア",
      priceIncrease: 190103,
      priceReduction: 190203,
      volume: 190303,
      link: "/overseas/ranking",
      transitionExchange: 20,
    },
  ],
  //インドネシア
  Indonesia_Ranking: [
    {
      id: 0,
      name: "インドネシア",
      priceIncrease: 180103,
      priceReduction: 180203,
      volume: 180303,
      link: "/overseas/ranking",
      transitionExchange: 21,
    },
  ],
  //フィリピン
  Philippine_Ranking: [
    {
      id: 0,
      name: "フィリピン",
      priceIncrease: 200103,
      priceReduction: 200203,
      volume: 200303,
      link: "/overseas/ranking",
      transitionExchange: 22,
    },
  ],
  //決算
  settlementPeriod: map(
    getSomeMonths(settlementPeriodMonth, "future"),
    (month: string, key: number) => {
      return {
        id: key,
        name: month,
      }
    }
  ),
}
